import PhoneForwardedRoundedIcon from '@mui/icons-material/PhoneForwardedRounded';
import PhoneCallbackRoundedIcon from '@mui/icons-material/PhoneCallbackRounded';
import PercentRoundedIcon from '@mui/icons-material/PercentRounded';
import ShowChartRoundedIcon from '@mui/icons-material/ShowChartRounded';
import WavesRoundedIcon from '@mui/icons-material/WavesRounded';

// The reports offered on the Report tab (desktop parity). Selected from the
// header title dropdown; each one exposes a different subset of filters.
// `section` is the desktop APP_ROUTES key persisted to sessionStorage
// ('currentSection') so a reload restores the same report (see MobileRouter).
export const REPORTS = [
  {
    key: 'CALLS',
    labelKey: 'OUTBOUND_CALLS',
    Icon: PhoneForwardedRoundedIcon,
    section: 'OUTBOUNDCALLSANALYSIS',
  },
  {
    key: 'INBOUND',
    labelKey: 'INBOUND_CALLS',
    Icon: PhoneCallbackRoundedIcon,
    section: 'INBOUNDCALLSANALYSIS',
  },
  {
    key: 'REDEMPTION',
    labelKey: 'MONTHLY_REDEMPTION',
    Icon: PercentRoundedIcon,
    section: 'REDEMPTIONREPORT',
  },
  {
    key: 'ROLLING',
    labelKey: 'ROLLING_REDEMPTION',
    Icon: ShowChartRoundedIcon,
    section: 'ROLLINGREDEMPTIONREPORT',
  },
  {
    key: 'WAVE',
    labelKey: 'WAVE',
    Icon: WavesRoundedIcon,
    section: 'WAVEACTIVITIESREPORT',
  },
];

// The desktop section keys backing the Report tab (used by MobileRouter to
// restore the Report tab on reload).
export const REPORT_SECTIONS = REPORTS.map((r) => r.section);

// report key <-> desktop section key helpers.
export const sectionForReport = (key) =>
  REPORTS.find((r) => r.key === key)?.section;
export const reportForSection = (section) =>
  REPORTS.find((r) => r.section === section)?.key;

// Which filters each report exposes (mirrors the desktop filter navbars).
export const FILTER_CONFIG = {
  CALLS: {
    showPeriod: true,
    showGrouping: true,
    showBranches: true,
    showSections: true,
    showOperator: true,
  },
  INBOUND: { showPeriod: true, showGrouping: true, showBranches: true },
  REDEMPTION: { showPeriod: true },
  ROLLING: {},
  WAVE: { showPeriod: true, showBranches: true },
};

// The Branch/User scope toggle is shown always (on-screen, not in the filter
// sheet) for these reports.
export const SCOPE_REPORTS = ['REDEMPTION', 'ROLLING'];

// Applied filters (a Confirm button in the sheet commits the draft to these,
// so editing filters never fires more than one request). Scope lives outside
// this object because it is an always-visible, apply-on-change control.
export const BASE_FILTERS = {
  monthOffset: 0,
  grouping: 'D',
  branches: [],
  sections: [],
  operator: 0,
};
